import { render } from "./package.vue?vue&type=template&id=3fe80ab8&scoped=true"
import script from "./package.vue?vue&type=script&lang=js"
export * from "./package.vue?vue&type=script&lang=js"

import "./package.vue?vue&type=style&index=0&id=3fe80ab8&scoped=true&lang=css"

import exportComponent from "D:\\project\\xiongmao-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe80ab8"]])

export default __exports__